import {URLPathname} from 'interfaces';
import {lazy} from 'react';
import {type RouteObject} from 'react-router-dom';

const ShortTermPlanningView = lazy(async () => await import('containers/views/planViews/ShortTermPlanningView'));
const TableView = lazy(async () => await import('containers/views/planViews/TableView'));
const LongTermPlanningView = lazy(async () => await import('containers/views/planViews/LongTermPlanningView'));
const ConcessionsView = lazy(async () => await import('containers/views/planViews/ConcessionsView'));
const LiveFishTransactions = lazy(async () => await import('containers/views/planViews/LiveFishTransactionsView'));
const EventsTableView = lazy(async () => await import('containers/views/planViews/EventsTableView'));
const PlanModelsView = lazy(async () => await import('containers/views/planViews/PlanModelsView'));
const OptimizationSettingsView = lazy(async () => await import('containers/views/planViews/OptimizationSettingsView'));
const SmoltSupplyAndInputs = lazy(async () => await import('components/SmoltSupply/SmoltSupplyView'));
const PlanHistoryView = lazy(async () => await import('containers/views/planViews/PlanHistoryView'));
const PlanHarvestDemandView = lazy(async () => await import('containers/views/planViews/PlanHarvestDemandView'));
const PlanFishTypesView = lazy(async () => await import('containers/views/planViews/PlanFishTypesView'));
const HarvestPlantView = lazy(async () => await import('containers/views/planViews/HarvestPlantView'));
const OrganizationOverviewView = lazy(async () => await import('containers/views/planViews/OrganizationOverviewView'));
const PivotTableView = lazy(async () => await import('containers/views/planViews/PivotTableView'));
const PlanVersionsView = lazy(async () => await import('containers/views/planViews/PlanVersionsView'));
const FishGroupsView = lazy(async () => await import('containers/views/planViews/FishGroupsView'));

const OverviewView = lazy(async () => await import('containers/views/planViews/OverviewView'));
const HarvestOverview = lazy(async () => await import('components/Overview/HarvestOverview'));
const InputOverview = lazy(async () => await import('components/Overview/InputOverview'));
const HarvestExplanationOverview = lazy(async () => await import('components/Overview/HarvestExplanationOverview'));

const HarvestLossModel = lazy(async () => await import('components/Models/HarvestLossModel'));
const FCRModel = lazy(async () => await import('components/Models/FCRModel'));
const StarvationModel = lazy(async () => await import('components/Models/Tabs/StarvationModel'));
const GrowthModels = lazy(async () => await import('components/Models/Tabs/GrowthModels'));
const MortalityModels = lazy(async () => await import('components/Models/Tabs/MortalityModels'));
const QualityGradingsModels = lazy(async () => await import('components/Models/Tabs/QualityGradingModels'));
const SalesPriceModels = lazy(async () => await import('components/Models/Tabs/SalesPriceModels'));
const CompaniesView = lazy(async () => await import('containers/views/planViews/CompaniesView'));
const FishGroupPropertiesView = lazy(async () => await import('containers/views/planViews/FishGroupPropertiesView'));

export const planRoutes: RouteObject[] = [
  {
    path: URLPathname.shortTermPlanning,
    element: <ShortTermPlanningView />,
  },
  {
    path: URLPathname.overviewTable,
    element: <TableView display={true} />,
  },
  {
    path: URLPathname.planning,
    element: <LongTermPlanningView />,
  },
  {
    path: URLPathname.concessions,
    element: <ConcessionsView />,
  },
  {
    path: URLPathname.liveFishTransactions,
    element: <LiveFishTransactions />,
  },
  {
    path: URLPathname.events,
    element: <EventsTableView />,
  },
  {
    path: URLPathname.fishGroups,
    element: <FishGroupsView />,
  },
  {
    path: URLPathname.planModels,
    element: <PlanModelsView />,
    children: [
      {
        element: <SalesPriceModels />,
        index: true,
      },
      {
        path: URLPathname.planModelsQualityGradings,
        element: <QualityGradingsModels />,
      },
      {
        path: URLPathname.planModelsMortalityModels,
        element: <MortalityModels />,
      },
      {
        path: URLPathname.planModelsGrowthModels,
        element: <GrowthModels />,
      },
      {
        path: URLPathname.planModelsStarvationModel,
        element: <StarvationModel />,
      },
      {
        path: URLPathname.planModelsHarvestLossModel,
        element: <HarvestLossModel />,
      },
      {
        path: URLPathname.planModelsFCRModel,
        element: <FCRModel />,
      },
    ],
  },
  {
    path: URLPathname.optimizationSettings,
    element: <OptimizationSettingsView />,
  },
  {
    path: URLPathname.smoltSupply,
    element: <SmoltSupplyAndInputs />,
  },
  {
    path: URLPathname.fishGroupProperties,
    element: <FishGroupPropertiesView />,
  },
  {
    path: URLPathname.planHistory,
    element: <PlanHistoryView />,
  },
  {
    path: URLPathname.planHarvestDemand,
    element: <PlanHarvestDemandView />,
  },
  {
    path: URLPathname.fishTypes,
    element: <PlanFishTypesView />,
  },
  {
    path: URLPathname.harvestPlant,
    element: <HarvestPlantView />,
  },
  {
    path: URLPathname.organizationOverview,
    element: <OrganizationOverviewView />,
  },
  {
    path: URLPathname.pivotTable,
    element: <PivotTableView />,
  },
  {
    path: URLPathname.planVersions,
    element: <PlanVersionsView />,
  },
  {
    path: URLPathname.planOverview,
    element: <OverviewView />,
    children: [
      {
        element: <HarvestOverview />,
        index: true,
      },
      {
        path: URLPathname.planOverviewInputs,
        element: <InputOverview />,
      },
      {
        path: URLPathname.planOverviewExplanations,
        element: <HarvestExplanationOverview />,
      },
    ],
  },
  {
    path: URLPathname.companies,
    element: <CompaniesView />,
  },
];
